import { useCountry } from 'hooks/useCountry'

import credibility from './svgs/credibility.svg?url'
import credibilityFr from './svgs/credibilityFr.svg?url'
import documentTaggingDk from './svgs/documentTaggingDk.svg?url'
import documentTaggingSe from './svgs/documentTaggingSe.svg?url'
import exploreDk from './svgs/exploreDk.svg?url'
import exploreSe from './svgs/exploreSe.svg?url'
import feedback from './svgs/feedback.svg?url'
import promptSuggestionsDk from './svgs/promptSuggestionsDk.svg?url'
import promptSuggestionsSe from './svgs/promptSuggestionsSe.svg?url'
import reasoningDk from './svgs/reasoningDk.svg?url'
import reasoningSe from './svgs/reasoningSe.svg?url'
import referencePreviewDk from './svgs/referencePreviewDk.svg?url'
import referencePreviewSe from './svgs/referencePreviewSe.svg?url'
import security from './svgs/security.svg?url'
import welcome from './svgs/welcome.svg?url'

import type { FC } from 'react'

type Props = {
  screen: string
}

export const ScreenGraphics: FC<Props> = ({ screen }) => {
  const country = useCountry()

  const getImage = () => {
    switch (screen) {
      case 'explore':
        return country === 'dk' ? exploreDk : exploreSe
      case 'welcome':
        return welcome
      case 'credibility':
        return country === 'fr' ? credibilityFr : credibility
      case 'security':
        return security
      case 'feedback':
        return feedback
      case 'reasoning':
        return country === 'dk' ? reasoningDk : reasoningSe
      case 'referencePreview':
        return country === 'dk' ? referencePreviewDk : referencePreviewSe
      case 'promptSuggestions':
        return country === 'dk' ? promptSuggestionsDk : promptSuggestionsSe
      case 'documentTagging':
        return country === 'dk' ? documentTaggingDk : documentTaggingSe
      default:
        return ''
    }
  }

  const imagePath = getImage()

  if (!imagePath) {
    return null
  }

  return (
    <img className="sm:min-h-56" alt="onboarding-carousel" src={imagePath} />
  )
}
